<template>
	<div style="width: 75rem;margin: 0 auto;margin-top: 1.875rem;">
		<p style="font-size: 1.5rem;">武汉大学人民医院新增动物实验申请</p>
		<p style="font-size: 1rem;">一、实验项目信息</p>
		<a-form-model ref="ruleForm" :model="form" :rules="rules">
			<a-row>
				<a-col :span="10">
					<a-form-model-item ref="name" label="实验项目名称" prop="item1.itemName">
						<a-input :disabled="this.$route.query.states=='申请新增'||this.$route.query.states=='编辑'"
							placeholder="请填写项目名称" v-model="form.item1.itemName" @blur="
			                 () => {
			                   $refs.name.onFieldBlur();
			                 }
			               " />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item label="项目类型" prop="item1.itemType">
						<a-radio-group :disabled="this.$route.query.states=='申请新增'||this.$route.query.states=='编辑'"
							v-model="form.item1.itemType" @change="changeItemType">
							<a-radio value="科学研究">
								科学研究
							</a-radio>
							<a-radio value="教学实验">
								教学实验
							</a-radio>
							<a-radio value="其他">
								其他
							</a-radio>
							<a-input :disabled="this.$route.query.states=='申请新增'||this.$route.query.states=='编辑'"
								v-model="form.item1.itemType" v-if="ItemTypeHide" style="width: 9.375rem;"></a-input>
						</a-radio-group>
					</a-form-model-item>
				</a-col>
				<a-col :span="10">
					<p style="position: absolute;left: 5.3125rem;top: 0.5rem;color: rgba(0, 0, 0, 0.45);">
						*即报销经费的来源，如：国自然面上项目80001000</p>
					<a-form-model-item ref="name" label="项目来源" prop="item1.itemSource">
						<a-input :disabled="this.$route.query.states=='申请新增'||this.$route.query.states=='编辑'"
							placeholder="请填写项目来源" v-model="form.item1.itemSource" @blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="项目编号" prop="item1.itemNum">
						<a-input :disabled="this.$route.query.states=='申请新增'||this.$route.query.states=='编辑'"
							placeholder="请填写项目编号" v-model="form.item1.itemNum" @blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
				</a-col>

				<a-col :span="10">
					<a-form-model-item ref="name" label="动物福利伦理审查号" prop="item1.approvalNo">
						<a-input placeholder="动物福利伦理审查号" v-model="form.item1.approvalNo" @blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item ref="name" label="拟申请有效期" prop="item1.itemNum">
						<a-input disabled placeholder="请填写项目编号"
							:value="form.item2.origin.startTime.split(' ')[0]+' - '+form.item2.origin.endTime.split(' ')[0]"
							@blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" style="margin: 16px 0pt;">
					<a-form-model-item ref="name" label="项目负责人">
						<a-input disabled placeholder="请填写项目负责人" v-model="form.newPage.boss.name" @blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="手机号">
						<a-input disabled placeholder="请填写手机号" v-model="form.newPage.boss.phone" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="邮箱">
						<a-input disabled placeholder="请填写邮箱" v-model="form.newPage.boss.email" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4" style="margin-top: 16px;margin-bottom: 16px;">
					<a-form-model-item ref="name" label="联系人">
						<a-input disabled placeholder="请填写项目负责人" v-model="form.newPage.people.name" @blur="
				             () => {
				               $refs.name.onFieldBlur();
				             }
				           " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="手机号">
						<a-input disabled placeholder="请填写手机号" v-model="form.newPage.people.phone" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
					<a-form-model-item ref="name" label="邮箱">
						<a-input disabled placeholder="请填写邮箱" v-model="form.newPage.people.email" @blur="
					         () => {
					           $refs.name.onFieldBlur();
					         }
					       " />
					</a-form-model-item>
				</a-col>

			</a-row>

			<p style="font-size: 1rem;margin-top: 1.5625rem;">二、新增动物实验信息</p>
			<a-row>
				<a-col :span="10">
					<a-checkbox-group @change="selectedTypes" v-model="form.item2.changeMsg"
						style="display: flex;flex-direction: column;">
						<a-checkbox value="拟延长有效期" name="type" style="margin-left: 0.5rem;">
							拟延长有效期
						</a-checkbox>
						<a-checkbox value="动物实验操作人员资质" name="type">
							动物实验操作人员资质
						</a-checkbox>
						<a-checkbox value="实验动物信息" name="type">
							实验动物信息
						</a-checkbox>
						<a-checkbox value="动物使用的理由和替代方法的检索" name="type">
							动物使用的理由和替代方法的检索
						</a-checkbox>
						<a-checkbox value="研究目的和意义" name="type">
							研究目的和意义
						</a-checkbox>
						<a-checkbox value="实验计划（设计）和基本实验操作" name="type">
							实验计划（设计）和基本实验操作
						</a-checkbox>
						<a-checkbox value="实验动物的麻醉" name="type">
							实验动物的麻醉
						</a-checkbox>
						<a-checkbox value="实验结束后的动物处理方法" name="type">
							实验结束后的动物处理方法
						</a-checkbox>
						<!-- <a-checkbox value="其他" name="type">
							其他
						</a-checkbox> -->
					</a-checkbox-group>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item>
						<div style="line-height: 1.875rem;font-size: 16px;margin-top: -35px;">
							新增原因</div>
						<a-input v-model="form.item2.reason" style="width: 30rem;height: 17.5rem;" type="textarea" />
					</a-form-model-item>
				</a-col>
			</a-row>
			<div v-show="form.item2.changeMsg.indexOf('拟延长有效期')!=-1">
				<!-- <a-col :span="24">
						<p style="font-size: 0.875rem;color: #000000A6;margin-top: 2.25rem;font-weight: bold;">原计划实验开展周期</p>
						
					</a-col>
					<a-col :span="10">
						<a-form-model-item ref="name" label="预计开始时间">
							<a-date-picker disabled style="width: 100%;" v-model="form.item2.origin.startTime"
								 show-time format="YYYY-MM-DD"
								 
								placeholder="选择开始日期"  />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">
						<a-form-model-item ref="name" label="预计结束时间">
							<a-date-picker disabled style="width: 100%;" v-model="form.item2.origin.endTime"
								 show-time format="YYYY-MM-DD" placeholder="选择结束日期"
								 />
						</a-form-model-item>
					</a-col> -->
				<a-row>
					<a-col :span="24">
						<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">拟延长有效期</p>
					</a-col>
					<a-col :span="10">
						<a-form-model-item ref="name" label="开始时间">
							<a-date-picker style="width: 100%;" v-model="form.item2.draw.startTime" show-time
								format="YYYY-MM-DD" :disabledDate="disabledDate" :allowClear="false"
								@change="changeTimes" placeholder="选择开始日期" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">
						<a-form-model-item ref="name" label="结束时间">
							<a-date-picker style="width: 100%;" v-model="form.item2.draw.endTime"
								:disabledDate="disabledDate2" :allowClear="false" show-time format="YYYY-MM-DD"
								placeholder="选择结束日期" />
						</a-form-model-item>
					</a-col>
				</a-row>

			</div>
			<a-row>
				<a-col :span="24" v-show="form.item2.changeMsg.indexOf('动物实验操作人员资质')!=-1">
					<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">新增动物实验操作人员资质</p>

					<a-table :scroll="{  y: 390 }" :pagination="{ pageSize: 10000 }" class="IACUC" bordered
						:data-source="form.item2.peopleMsg" :columns="columns">

						<template slot="name" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange2(record.key, 'name', $event)" />
						</template>
						<template slot="sex" slot-scope="text, record">
							<!-- <a-select style="width: 100px" :defaultValue="text" :text="text" @change="onCellChange2(record.key, 'sex', $event)">
									<a-select-option   key="男">
									    男
									</a-select-option>
									<a-select-option   key="女">
									    女
									</a-select-option>
								</a-select> -->
							<a-select style="width: 100px" :defaultValue="text" :text="text"
								@change="onCellChange2(record.key, 'sex', $event)">
								<a-select-option key="实验设计">
									实验设计
								</a-select-option>
								<a-select-option key="实验管理">
									实验管理
								</a-select-option>
								<a-select-option key="主操作">
									主操作
								</a-select-option>
								<a-select-option key="操作助手">
									操作助手
								</a-select-option>
								<a-select-option key="手术者">
									手术者
								</a-select-option>
								<a-select-option key="麻醉师">
									麻醉师
								</a-select-option>
								<a-select-option key="动物管理">
									动物管理
								</a-select-option>
							</a-select>
						</template>
						<template slot="department" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange2(record.key, 'department', $event)" />
						</template>
						<template slot="certificate" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange2(record.key, 'certificate', $event)" />
						</template>
						<!-- <template slot="experience" slot-scope="text, record">
								<a-input :defaultValue="text":text="text" @change="onCellChange2(record.key, 'experience', $event)" />
							</template> -->
						<template slot="ability" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange2(record.key, 'ability', $event)" />
						</template>
						<template slot="operation" slot-scope="text, record">
							<a-popconfirm okText="确认" cancelText="取消" v-if="form.item2.peopleMsg.length" title="确认是否删除?"
								@confirm="() => onDelete(record.key)">
								<a style="color: red;">删除</a>
							</a-popconfirm>
						</template>

					</a-table>
					<a-button style="width: 6.125rem;height: 2.25rem;margin-top: 2rem;" type="primary" icon="plus"
						@click="handleAdd">
						添加
					</a-button>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="24" v-show="form.item2.changeMsg.indexOf('实验动物信息')!=-1">
					<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">新增实验动物信息</p>

					<a-table :scroll="{  y: 390,x:300 }" :pagination="{ pageSize: 10000 }" class="IACUC" bordered
						:data-source="form.item2.animalMsg" :columns="columns2">
						<template slot="aniType" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'aniType', $event)" />
						</template>
						<!-- <template slot="level" slot-scope="text, record">
								<a-input :defaultValue="text":text="text" @change="onCellChange(record.key, 'level', $event)" />
							</template> -->
						<template slot="AgeWeight" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'AgeWeight', $event)" />
						</template>
						<template slot="AgeWeight2" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'AgeWeight2', $event)" />
						</template>
						<template slot="nums_1" slot-scope="text, record">
							<!-- <a-input :defaultValue="text":text="text" @change="onCellChange(record.key, 'nums_1', $event)" /> -->
							<a-select style="width: 100px" :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'nums_1', $event)">
								<a-select-option key="雄性">
									雄性
								</a-select-option>
								<a-select-option key="雌性">
									雌性
								</a-select-option>
								<a-select-option key="雌雄不限">
									雌雄不限
								</a-select-option>
							</a-select>
						</template>
						<template slot="nums_2" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'nums_2', $event)" />
						</template>
						<template slot="company" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'company', $event)" />
						</template>
						<template slot="license" slot-scope="text, record">
							<!-- <a-input :defaultValue="text":text="text" @change="onCellChange(record.key, 'license', $event)" /> -->
							<a-select style="width: 100px" :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'license', $event)">
								<a-select-option key="普通环境">
									普通环境
								</a-select-option>
								<a-select-option key="屏障环境">
									屏障环境
								</a-select-option>
								<a-select-option key="IVC环境">
									IVC环境
								</a-select-option>
								<a-select-option key="隔离环境">
									隔离环境
								</a-select-option>
							</a-select>
						</template>
						<template slot="locale" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'locale', $event)" />
						</template>
						<template slot="ifBreeding" slot-scope="text, record">
							<!-- <a-input :defaultValue="text":text="text" @change="onCellChange(record.key, 'ifBreeding', $event)" /> -->
							<a-select style="width: 100px" :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'ifBreeding', $event)">
								<a-select-option key="是">
									是
								</a-select-option>
								<a-select-option key="否">
									否
								</a-select-option>
							</a-select>
						</template>
						<template slot="spRequest" slot-scope="text, record">
							<a-input :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'spRequest', $event)" />
						</template>
						<template slot="ifGene" slot-scope="text, record">
							<!-- <a-input :defaultValue="text":text="text" @change="onCellChange(record.key, 'ifGene', $event)" /> -->
							<a-select style="width: 100px" :defaultValue="text" :text="text"
								@change="onCellChange(record.key, 'ifGene', $event)">
								<a-select-option key="是">
									是
								</a-select-option>
								<a-select-option key="否">
									否
								</a-select-option>
							</a-select>
						</template>
						<template slot="operation" slot-scope="text, record">
							<a-popconfirm okText="确认" cancelText="取消" v-if="form.item2.animalMsg.length" title="确认是否删除?"
								@confirm="() => onDelete2(record.key)">
								<a style="color: red;" href="javascript:;">删除</a>
							</a-popconfirm>
						</template>

					</a-table>
					<a-button style="width: 6.125rem;height: 2.25rem;margin-top: 2rem;" type="primary" icon="plus"
						@click="handleAdd2">
						添加
					</a-button>
				</a-col>
			</a-row>



			<div v-show="form.item2.changeMsg.indexOf('动物使用的理由和替代方法的检索')!=-1">
				<!-- 	<a-col :span="24">
					<p style="font-size: 0.875rem;color: #000000A6;margin-top: 2.25rem;font-weight: bold;">更改实验方法</p>
					
				</a-col>
				<a-col :span="10">
					<a-form-model-item >
						<div style="line-height: 1.875rem;">
							原实验方法</div>
						<a-input disabled style="width: 30rem;height: 17.5rem;" v-model="form.item2.orginMethod" type="textarea" />
					</a-form-model-item>
				</a-col>
				<a-col :span="10" :offset="4">
					<a-form-model-item >
						<div style="line-height: 1.875rem;">
							拟更改实验方法</div>
						<a-input style="width: 30rem;height: 17.5rem;" v-model="form.item2.draftMethod" type="textarea" />
					</a-form-model-item>
				</a-col>
				 -->
				<a-row style="margin-top: 0.85rem;">
					<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">新增动物使用的理由和替代方法的检索</p>
					<a-col :span="10">
						<a-form-model-item label="1.解释为什么你的研究中将要使用的动物种类是合理的">
							<a-checkbox-group v-model="form.newCode.text1"
								style="display: flex;flex-direction: column;">
								<a-checkbox value="本实验是以前使用该品种动物实验工作的直接延续" name="type" style="margin-left: 0.5rem;">
									本实验是以前使用该品种动物实验工作的直接延续
								</a-checkbox>
								<a-checkbox value="本研究致力于扩展以前的从其它品种到这个品种的实验结果" name="type">
									本研究致力于扩展以前的从其它品种到这个品种的实验结果
								</a-checkbox>
								<a-checkbox value="对于该品种动物很重要的生理/行为学现象，现在缺乏了解" name="type">
									对于该品种动物很重要的生理/行为学现象，现在缺乏了解
								</a-checkbox>
								<a-checkbox style="" value="对于这个品种动物重要的生理/行为学现象的相关内容比其他品种了解更多" name="type">
									对于这个品种动物重要的生理/行为学现象的相关内容比其他品种了解更多
								</a-checkbox>
								<a-checkbox value="这个品种的选择体现出了在能够使用的最低级的生物体和与人类的生理/行为最相近的模型系统中间最好的折衷方案" name="type">
									这个品种的选择体现出了在能够使用的最低级的生物体和与人类的生理/行为最相近的模型系统中间最好的折衷方案
								</a-checkbox>
								<a-checkbox value="对于计划开展的研究这个品种是最经济的" name="type">
									对于计划开展的研究这个品种是最经济的
								</a-checkbox>
								<!-- <a-checkbox value="其他" name="type">
				 					其他
				 				</a-checkbox> -->
							</a-checkbox-group>
						</a-form-model-item>
						<a-form-model-item>
							<div style="line-height: 1.875rem;">其他（请解释）</div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.textMsg1" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">

						<a-form-model-item label="2.在本实验中使用活体动物的理由是什么">
							<a-checkbox-group v-model="form.newCode.text2"
								style="display: flex;flex-direction: column;">
								<a-checkbox value="本研究要求对活体动物进行行为测量" name="type" style="margin-left: 0.5rem;">
									本研究要求对活体动物进行行为测量
								</a-checkbox>
								<a-checkbox value="本研究致力于扩展以前的从其它品种到这个品种的实验结果" name="type">
									本研究致力于扩展以前的从其它品种到这个品种的实验结果
								</a-checkbox>
								<a-checkbox value="本研究要求对活体动物进行生物学检测或活体动物的组织样本取材" name="type">
									本研究要求对活体动物进行生物学检测或活体动物的组织样本取材
								</a-checkbox>
								<a-checkbox style="" value="在本实验中，计算机或者其他模型不能代替动物" name="type">
									在本实验中，计算机或者其他模型不能代替动物
								</a-checkbox>
								<a-checkbox value="本研究不能做离体实验" name="type">
									本研究不能做离体实验
								</a-checkbox>
								<!-- <a-checkbox value="对于计划开展的研究这个品种是最经济的" name="type">
				 					对于计划开展的研究这个品种是最经济的
				 				</a-checkbox> -->
								<!-- <a-checkbox value="其他" name="type">
				 					其他
				 				</a-checkbox> -->
							</a-checkbox-group>
						</a-form-model-item>
						<a-form-model-item>
							<div style="line-height: 1.875rem;margin-top: 45px;">其他（请解释）</div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.textMsg2" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="3.所需动物数量的依据" style="width: 484px;">
							<a-checkbox-group v-model="form.newCode.text3"
								style="display: flex;flex-direction: column;">
								<a-checkbox value="统计分析显示，实验计划的（动物）数量是最少的，符合统计学上对实验假设进行有效检验的要求" name="type"
									style="margin-left: 0.5rem;">
									统计分析显示，实验计划的（动物）数量是最少的，符合统计学上对实验假设进行有效检验的要求
								</a-checkbox>
								<a-checkbox value="实验将进行多个独立因素结果的对比，因此要求多组" name="type">
									实验将进行多个独立因素结果的对比，因此要求多组
								</a-checkbox>
								<a-checkbox value="结果的检测或者被检测的现象是可变的，大样本量对于统计上有效的取样是必需的" name="type">
									结果的检测或者被检测的现象是可变的，大样本量对于统计上有效的取样是必需的
								</a-checkbox>
								<a-checkbox style="" value="来自于对照组的差异预计是很小的。对于可靠地区分组间差异，大样本量是必需的" name="type">
									来自于对照组的差异预计是很小的。对于可靠地区分组间差异，大样本量是必需的
								</a-checkbox>
								<a-checkbox value="实验具有技术上的困难，需要多次尝试以便从每一次实验中获得令人满意的数据" name="type">
									实验具有技术上的困难，需要多次尝试以便从每一次实验中获得令人满意的数据
								</a-checkbox>
								<!-- <a-checkbox value="对于计划开展的研究这个品种是最经济的" name="type">
				 					对于计划开展的研究这个品种是最经济的
				 				</a-checkbox> -->
								<!-- <a-checkbox value="其他" name="type">
				 					其他
				 				</a-checkbox> -->
							</a-checkbox-group>
						</a-form-model-item>
						<a-form-model-item>
							<div style="line-height: 1.875rem;">其他（请解释）</div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.textMsg3" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10">
						<div style="margin-bottom: 16px;;font-size: 14px;">
							4.寻找活体动物使用的替代方法
						</div>
						<a-form-model-item label="4.1 至少列出2种查阅的数据库（如：中国知网、PubMed等）">

							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text4" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">

						<a-form-model-item style="width: 50px;height: 26px;">

						</a-form-model-item>
						<a-form-model-item>
							<div style="line-height: 1.875rem;">检索日期</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<!-- <a-input style="width: 30rem;height: 2rem" v-model="form.newCode.text5"  /> -->
							<a-date-picker style="width: 96%;" v-model="form.newCode.text5" show-time
								format="YYYY-MM-DD" placeholder="请选择日期" />
						</a-form-model-item>
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<!-- <a-form-model-item label=" " style="width: 50px;height: 42px;">
				 			
				 		</a-form-model-item> -->
						<a-form-model-item>
							<div style="line-height: 1.875rem;">检索涵盖的年份</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text6" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10">
						<!-- <a-form-model-item label=" " style="width: 50px;height:0px;">
				 			
				 		</a-form-model-item> -->
						<a-form-model-item>
							<div style="line-height: 1.875rem;">4.2 动物福利相关关键词（如：动物模型，非动物模型，在体外、替代、组织）</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text7" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">
						<!-- <a-form-model-item label=" " style="width: 50px;height:0px;">
				 			
				 		</a-form-model-item> -->
						<a-form-model-item>
							<div style="line-height: 1.875rem;">项目相关的关键词</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text8" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item>
							<div style="line-height: 1.875rem;">
								4.3 说明必须使用动物而不用非动物替代方法</div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.item3.textarea1" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</div>
			<div v-show="form.item2.changeMsg.indexOf('研究目的和意义')!=-1">
				<a-row>
					<p style="font-size: 1rem;margin-top: 0.3625rem;font-weight: bolder;">新增研究目的和意义</p>
					<a-col :span="24">
						<a-form-model-item style="width: 484px;">
							<div style="line-height: 1.875rem;">以一般非生物医学背景人员为对象，用通俗的语言描述研究目的（做什么？），对人类、动物的健康或科学的贡献</div>
							<a-input style="width: 30rem;height: 17.5rem;" v-model="form.item3.textarea3"
								type="textarea" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</div>
			<div v-show="form.item2.changeMsg.indexOf('实验计划（设计）和基本实验操作')!=-1">
				<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">新增实验计划（设计）和基本实验操作</p>
				<a-col :span="24">

					<a-form-model-item>
						<div style="line-height: 1.875rem;margin-top: 1rem;">1.是否属于遗传工程动物繁殖</div>
						<a-radio-group v-model="form.item4.isGeneti">
							<a-radio value="否">
								否
							</a-radio>
							<a-radio value="是">
								是
							</a-radio>
						</a-radio-group>
					</a-form-model-item>

				</a-col>
				<a-row v-if="form.item4.isGeneti=='是'">
					<a-col :span="10">
						<a-form-model-item>
							<div style="line-height: 1.875rem;">繁殖方式</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height:2rem;" v-model="form.newCode.text11" />
						</a-form-model-item>
					</a-col>

					<a-col :span="10" :offset="4">

						<a-form-model-item>
							<div style="line-height: 1.875rem;">乳鼠鉴定时间</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text12" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10">

						<a-form-model-item>
							<div style="line-height: 1.875rem;">离乳时间</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text13" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">

						<a-form-model-item>
							<div style="line-height: 1.875rem;">阴性鼠处理方式</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text14" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="10">
						<div style="line-height: 1.875rem;margin-top: 1rem;">2.描述项目实验计划（设计）和主要实验操作程序</div>
						<a-form-model-item>
							<div style="line-height: 1.875rem;margin-top: 1rem;">2.1 实验分组（描述实验组、对照组、动物数）</div>
							<div style="line-height: 1.875rem;"></div>
							<a-input style="width: 30rem;height: 7.5rem;" v-model="form.newCode.text15"
								type="textarea" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item>
							<div style="line-height: 1.875rem;margin-top: 1rem;">2.2 主要实验流程</div>

							<a-table :scroll="{  y: 390 ,x:300}" :pagination="{ pageSize: 10000 }" class="IACUC"
								bordered :data-source="form.item3.experProcess" :columns="columns3">
								<template slot="exTxt" slot-scope="text, record">
									<a-input placeholder="适应性饲养期" :defaultValue="text" :text="text"
										@change="onCellChange3(record.key, 'exTxt', $event)" />
								</template>
								<template slot="exTime" slot-scope="text, record">
									<a-input placeholder="实验前3-7天" :defaultValue="text" :text="text"
										@change="onCellChange3(record.key, 'exTime', $event)" />
								</template>

								<template slot="operation" slot-scope="text, record">
									<a-popconfirm okText="确认" cancelText="取消" v-if="form.item3.experProcess.length"
										title="确认是否删除?" @confirm="() => onDelete3(record.key)">
										<a style="color: red;" href="javascript:;">删除</a>
									</a-popconfirm>
								</template>

							</a-table>
							<a-button style="width: 6.125rem;height: 2.25rem;margin-top: 2rem;" type="primary"
								icon="plus" @click="handleAdd3">
								添加
							</a-button>
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="2.3 动物实验给药">

							<a-radio-group v-model="form.item4.isPill">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>


						</a-form-model-item>
					</a-col>


					<a-col :span="24" v-if="form.item4.isPill=='是'">
						<a-form-model-item>
							<a-table :scroll="{  y: 390 ,x:300}" :pagination="{ pageSize: 10000 }" class="IACUC"
								bordered :data-source="form.item3.pillType" :columns="columns4">

								<template slot="drugType" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange4(record.key, 'drugType', $event)" />
								</template>
								<template slot="name" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange4(record.key, 'name', $event)" />
								</template>
								<template slot="dose" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange4(record.key, 'dose', $event)" />
								</template>
								<template slot="position" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange4(record.key, 'position', $event)" />
								</template>
								<template slot="time" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange4(record.key, 'time', $event)" />
								</template>

								<template slot="operation" slot-scope="text, record">
									<a-popconfirm okText="确认" cancelText="取消" v-if="form.item3.pillType.length"
										title="确认是否删除?" @confirm="() => onDelete4(record.key)">
										<a style="color: red;" href="javascript:;">删除</a>
									</a-popconfirm>
								</template>

							</a-table>
							<a-button style="width: 6.125rem;height: 2.25rem;margin-top: 2rem;" type="primary"
								icon="plus" @click="handleAdd4">
								添加
							</a-button>
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="2.4 是否采血">
							<a-radio-group v-model="form.item4.isBlood">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item v-if="form.item4.isBlood=='是'">
							<div style="line-height: 1.875rem;margin-top: 0rem;">频率（于实验第几天？）</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text16" />
						</a-form-model-item>
					</a-col>
					<div v-if="form.item4.isBlood=='是'">
						<a-col :span="10">

							<a-form-model-item>
								<div style="line-height: 1.875rem;margin-top: 0;">采血部位</div>
								<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
								<a-input style="width: 30rem;height:2rem;" v-model="form.newCode.text17" />
							</a-form-model-item>
						</a-col>
						<a-col :span="10" :offset="4">


							<a-form-model-item>
								<div style="line-height: 1.875rem;">每次每只动物的最大采血</div>
								<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
								<a-input style="width: 30rem;height:2rem;" v-model="form.newCode.text18" />
							</a-form-model-item>
						</a-col>
					</div>

					<a-col :span="10">
						<a-form-model-item label="2.5 预期实验会对动物造成的伤害" style="width: 484px;">
							<a-checkbox-group v-model="form.newCode.text19"
								style="display: flex;flex-direction: column;">
								<a-checkbox value="肿瘤生长" name="type" style="margin-left: 0.5rem;">
									肿瘤生长
								</a-checkbox>
								<a-checkbox value="体重增加或减少" name="type">
									体重增加或减少
								</a-checkbox>
								<a-checkbox value="丧失饮食饮水能力" name="type">
									丧失饮食饮水能力
								</a-checkbox>
								<a-checkbox style="" value="死亡" name="type">
									死亡
								</a-checkbox>
							</a-checkbox-group>
						</a-form-model-item>
						<!-- <a-form-model-item>
								<div style="line-height: 1.875rem;">其它异常临床症状需要说明的情况</div>
								<a-input style="width: 30rem;height: 7.5rem;" v-model="form.newCode.textMsg19" type="textarea" />
							</a-form-model-item> -->
						<a-form-model-item>
							<div style="line-height: 1.275rem;">
								详细列出对动物可能造成的所有可预期的伤害，包括动物运输，动物饲养方式（如单笼饲养）、实验操作步骤中等可能产生伤害或不适的细节以及拟采取的防控优化措施(包括麻醉、止痛和镇静，保温，环境丰容等)。涉及给药，应列出药物名称、剂量、给药途径及时间。
							</div>
							<a-input style="width: 30rem;height: 5.2rem;" v-model="form.item4.textarea2"
								type="textarea" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">

						<!-- <a-form-model-item label=" " style="width: 50px;height: 42px;">
								
							</a-form-model-item> -->
						<a-form-model-item prop="newCode.text20">
							<div style="line-height: 1.875rem;">2.6 主要实验流程（造模或手术过程）</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 17.5rem;" v-model="form.newCode.text20"
								type="textarea" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="2.7 样品采集">

							<a-radio-group v-model="form.item4.isSample">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>


						</a-form-model-item>
					</a-col>


					<a-col :span="24" v-if="form.item4.isSample=='是'">
						<a-form-model-item>
							<a-table :scroll="{  y: 390 ,x:300}" :pagination="{ pageSize: 10000 }" class="IACUC"
								bordered :data-source="form.item3.sampleCol" :columns="columns5">

								<template slot="name" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange5(record.key, 'name', $event)" />
								</template>
								<template slot="position" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange5(record.key, 'position', $event)" />
								</template>
								<template slot="times" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange5(record.key, 'times', $event)" />
								</template>
								<template slot="way" slot-scope="text, record">
									<a-input :defaultValue="text" :text="text"
										@change="onCellChange5(record.key, 'way', $event)" />
								</template>


								<template slot="operation" slot-scope="text, record">
									<a-popconfirm okText="确认" cancelText="取消" v-if="form.item3.sampleCol.length"
										title="确认是否删除?" @confirm="() => onDelete5(record.key)">
										<a style="color: red;" href="javascript:;">删除</a>
									</a-popconfirm>
								</template>

							</a-table>
							<a-button style="width: 6.125rem;height: 2.25rem;margin-top: 2rem;" type="primary"
								icon="plus" @click="handleAdd5">
								添加
							</a-button>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="10">

						<a-form-model-item label="">
							<div style="line-height: 1.875rem;margin-top: 1rem;">3.是否使用有毒化学品或药品</div>
							<a-radio-group v-model="form.item4.isToxic">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item prop="item4.isToxic" v-if="form.item4.isToxic=='是'">
							<div style="line-height: 1.875rem;margin-top: 0rem;">请描述来源</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.item4.textarea6" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">

						<a-form-model-item>
							<div style="line-height: 1.875rem;margin-top: 1rem;">4.是否使用重组DNA或病原微生物</div>
							<a-radio-group v-model="form.item4.isDna">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>
							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item v-if="form.item4.isDna=='是'">
							<div style="line-height: 1.875rem;margin-top: 0rem;">请描述来源</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text22" />
						</a-form-model-item>
					</a-col>
				</a-row>


				<a-row>
					<a-col :span="10">
						<a-form-model-item>
							<div style="line-height: 1.875rem;">5.对直接接触人员可能的进入途径</div>
							<a-checkbox-group v-model="form.newCode.text23"
								style="display: flex;flex-direction: column;">
								<a-checkbox value="吸入" name="type" style="margin-left: 0.5rem;">
									吸入
								</a-checkbox>
								<a-checkbox value="消化道 " name="type">
									消化道
								</a-checkbox>
								<a-checkbox value="皮肤接触" name="type">
									皮肤接触
								</a-checkbox>
								<a-checkbox style="" value="注射" name="type">
									注射
								</a-checkbox>

							</a-checkbox-group>
						</a-form-model-item>
						<a-form-model-item>
							<div style="line-height: 1.875rem;">其它（具体说明）</div>
							<a-input style="width: 30rem;height: 2rem;" v-model="form.newCode.text23Msg" />
						</a-form-model-item>
					</a-col>

					<a-col :span="10" :offset="4">
						<a-form-model-item style="margin-top: 0;">
							<div style="line-height: 1.875rem;margin-top: 0rem;">6.防护性措施</div>
							<a-checkbox-group v-model="form.newCode.text25"
								style="display: flex;flex-direction: column;">
								<a-checkbox value="防毒面具 " name="type" style="margin-left: 0.5rem;">
									防毒面具
								</a-checkbox>
								<a-checkbox value="安全眼镜（或密封保护镜) " name="type">
									安全眼镜（或密封保护镜)
								</a-checkbox>
								<a-checkbox value="手套" name="type">
									手套
								</a-checkbox>
								<a-checkbox style="" value="防护服" name="type">
									防护服
								</a-checkbox>
								<a-checkbox value="机械通风笼具 " name="type" style="margin-left: 0.5rem;">
									机械通风笼具
								</a-checkbox>
								<a-checkbox value="通风柜 " name="type">
									通风柜
								</a-checkbox>
								<a-checkbox value="生物安全柜" name="type">
									生物安全柜
								</a-checkbox>
								<a-checkbox style="" value="其他(特殊的)" name="type">
									其他(特殊的)
								</a-checkbox>
							</a-checkbox-group>
						</a-form-model-item>

					</a-col>
					<a-col :span="24">


						<a-form-model-item>
							<div style="line-height: 1.875rem;margin-top: 0rem;">7.对人员健康的潜在危害性</div>
							<div style="line-height: 1.875rem;margin-top: 0rem;"></div>
							<a-input style="width: 30rem;height:2rem;" v-model="form.newCode.text24" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</div>
			<div v-show="form.item2.changeMsg.indexOf('实验动物的麻醉')!=-1">
				<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">新增实验动物的麻醉</p>
				<a-row>
					<div style="line-height: 1.875rem;font-size: 15px;font-weight: 500;">根据实验对动物造成的疼痛、应激或不舒适性进行分类。
						如果为3类，需要用科学的判断方法来解释为何实验处置中所致的持续性的疼痛与不适不能应用麻醉、止痛或镇静方法来减轻的理由。简要描述可能发生的持续性的疼痛与不适、解决办法或认为没有可行的解决办法。
					</div>
					<a-col :span="10">
						<div style="line-height: 1.875rem;margin-top: 20px;">1类：仅引起短暂性的疼痛，无需麻醉；或无痛、无应激</div>
						<a-form-model-item>
							<a-radio-group @change="onlyValues(1)" v-model="form.newCode.text26">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="4">
						<div style="line-height: 1.875rem;margin-top: 20px;">2类：可用适当方法减轻疼痛和/或应激</div>
						<a-form-model-item>
							<a-radio-group @change="onlyValues(2)" v-model="form.newCode.text27">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>
						</a-form-model-item>

					</a-col>
					<a-col :span="10">

						<a-form-model-item label="3类：不能使用适当方法以减轻疼痛或持续性不适">
							<a-radio-group @change="onlyValues(3)" v-model="form.item4.isPain">
								<a-radio value="否">
									否
								</a-radio>
								<a-radio value="是">
									是
								</a-radio>

							</a-radio-group>
						</a-form-model-item>

					</a-col>
					<a-col :span="24">
						<a-form-model-item>

							<div style="line-height: 1.875rem;">说明（麻醉药品及麻醉方式）</div>
							<a-input style="width: 30rem;height: 2rem" v-model="form.newCode.textMsg28" />


						</a-form-model-item>
					</a-col>
				</a-row>
			</div>
			<div v-show="form.item2.changeMsg.indexOf('实验结束后的动物处理方法')!=-1">
				<a-row style="margin-top: 0;">
					<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">新增实验后的实验动物处理方法</p>
					<a-col :span="24">
						<a-form-model-item label="1.实验结束后的动物处理方法及其他需说明的问题">
							<a-checkbox-group v-model="form.item4.death" style="display: flex;flex-direction: column;">
								<a-checkbox value="过量麻醉药" name="type" style="margin-left: 0.5rem;">
									过量麻醉药
								</a-checkbox>
								<a-checkbox value="二氧化碳吸入" name="type">
									二氧化碳吸入
								</a-checkbox>
								<a-checkbox value="物理方法（颈椎脱臼、断头等）" name="type">
									物理方法（颈椎脱臼、断头等）
								</a-checkbox>
								<a-checkbox value="领养" name="type">
									领养
								</a-checkbox>

							</a-checkbox-group>
						</a-form-model-item>
						<a-form-model-item>
							<div style="line-height: 1.875rem;">其它要说明的问题 </div>
							<a-input style="width: 30rem;height: 2rem" v-model="form.item4.textarea4" />
						</a-form-model-item>
					</a-col>
					<a-col :span="10" :offset="0">
						<a-form-model-item>
							<div style="line-height: 1.875rem;">2.仁慈终点或实验终结的指标(既终止实验的时机)。</div>
							<a-input style="width: 30rem;height: 7.5rem;;" v-model="form.item4.textarea3"
								type="textarea" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</div>

			<div v-show="form.item2.changeMsg.indexOf('其他')!=-1">
				<a-row>
					<a-col :span="24">
						<p style="font-size: 0.875rem;color: #000000A6;margin-top: 2.25rem;font-weight: bold;">其他</p>

					</a-col>
					<a-col :span="24">
						<a-form-model-item>
							<div style="line-height: 1.875rem;">
								详细说明</div>
							<a-input style="width: 30rem;height: 17.5rem;" v-model="form.item2.otherMethod"
								type="textarea" />
						</a-form-model-item>
					</a-col>
				</a-row>

			</div>


			</a-row>
			<a-row>
				<p style="font-size: 1rem;margin-top: 1.5625rem;font-weight: bolder;">三、项目负责人的申明</p>
				<a-col :span="10">

					<div style="line-height: 1.5625rem">

						<div>1.我保证在此提请的陈述是完整的且准确的，本方案中的动物使用没有单纯重复以前的实验</div>

						<div>2.如果方案被批准，我同意以书面形式告知实验动物福利伦理委员会任何的紧急情况，且同意在问题解决之前将不会继续实验</div>
						<div>3.没有提交实验方案的书面修改稿给实验动物福利伦理委员会，且经伦理委员会审查、批准之前，我将不会对涉及动物的程序做出较大的改动</div>


					</div>

				</a-col>
				<a-col :span="10" :offset="4">
					<div style="line-height: 1.5625rem;margin-top: 0rem;">
						<div>4.保证每个从事与动物有关的工作人员接受合适的培训是我的职责</div>
						<div>5.在收到实验动物福利伦理委员会的批准通知之前，我不会开始本方案中所描述的实验操作</div>
						<div>6.我将保留一个本实验方案的副本及随后所有的通信资料</div>
					</div>
				</a-col>
			</a-row>
			<div style="display: flex;justify-content: center;margin: 8.125rem 0;"
				v-if="this.$route.query.status!=='详情'&&this.$route.query.states!=='PI审核'">
				<a-button @click="onSubmit" type="primary" style="width: 22.5rem;height: 3.75rem;">
					提交
				</a-button>
			</div>
			<div style="display: flex;justify-content: center;margin: 8.125rem 0;"
				v-else-if="this.$route.query.status=='详情'">
				<a-button @click="$router.go(-1)" type="primary" style="width: 22.5rem;height: 3.75rem;">
					返回
				</a-button>
			</div>
			<div style="display: flex;justify-content: center;margin: 8.125rem 0;"
				v-else-if="this.$route.query.states=='PI审核'">
				<a-popconfirm title="该新增实验是否审核通过?" ok-text="通过" cancel-text="否决" @confirm="EthicalChangePiReview(true)"
					@cancel="EthicalChangePiReview(false)">
					<a-button type="primary" style="width: 22.5rem;height: 3.75rem;">
						审核
					</a-button>
				</a-popconfirm>
			</div>

		</a-form-model>
	</div>
</template>

<script>
	import {
		SelUserList,
		SelEthicalChange,
		AppEthicalChange,
		UpdateEthicalChange,
		SelIacuc
	} from '@/api/index.js'
	import moment from 'moment'
	import EditableCell from '../../../components/editableCell.vue'
	import axios from 'axios'
	import Qs from 'qs'
	export default {
		name: '/core/ethicsChange',
		components: {
			EditableCell,
		},
		data() {
			return {
				count: 1,
				ItemTypeHide: false,
				ethicsChangeData: [],
				columns: [{
						title: '姓名',
						dataIndex: 'name',
						scopedSlots: {
							customRender: 'name'
						},
					},
					{
						title: '项目职责',
						dataIndex: 'sex',
						scopedSlots: {
							customRender: 'sex'
						},
					},
					{
						title: '职称',
						dataIndex: 'department',
						scopedSlots: {
							customRender: 'department'
						},
					},
					{
						title: '实验动物从业人员考核合格证编号',
						dataIndex: 'certificate',
						scopedSlots: {
							customRender: 'certificate'
						},
						width: 250
					},
					// {
					// 	title: '动物实验经验',
					// 	dataIndex: 'experience',
					// 	scopedSlots: {
					// 		customRender: 'experience'
					// 	},
					// },
					// {
					// 	title: '职责',
					// 	dataIndex: 'ability',
					// 	scopedSlots: {
					// 		customRender: 'ability'
					// 	},

					// },
					{
						title: '编辑',
						dataIndex: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
						width: 80
					},
				],
				columns3: [{
						title: '时间',
						dataIndex: 'exTime',
						scopedSlots: {
							customRender: 'exTime'
						},
						width: 260
					},
					{
						title: '内容',
						dataIndex: 'exTxt',
						scopedSlots: {
							customRender: 'exTxt'
						},

					},

					{
						title: '编辑',
						dataIndex: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
						aligh: 'center',
						width: 80
					},
				],
				columns4: [{
						title: '给药方式',
						dataIndex: 'drugType',
						scopedSlots: {
							customRender: 'drugType'
						},

					},
					{
						title: '物质名称',
						dataIndex: 'name',
						scopedSlots: {
							customRender: 'name'
						},

					},
					{
						title: '剂量',
						dataIndex: 'dose',
						scopedSlots: {
							customRender: 'dose'
						},

					},
					{
						title: '部位（如皮下、脑腔等）',
						dataIndex: 'position',
						scopedSlots: {
							customRender: 'position'
						},

					},
					{
						title: '时间点',
						dataIndex: 'time',
						scopedSlots: {
							customRender: 'time'
						},

					},

					{
						title: '编辑',
						dataIndex: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
						aligh: 'center',
						width: 80
					},
				],
				columns5: [{
						title: '样品名称',
						dataIndex: 'name',
						scopedSlots: {
							customRender: 'name'
						},

					},
					{
						title: '部位',
						dataIndex: 'position',
						scopedSlots: {
							customRender: 'position'
						},

					},
					{
						title: '频率或时间点',
						dataIndex: 'times',
						scopedSlots: {
							customRender: 'times'
						},

					},
					{
						title: '方法',
						dataIndex: 'way',
						scopedSlots: {
							customRender: 'way'
						},

					},


					{
						title: '编辑',
						dataIndex: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
						aligh: 'center',
						width: 80
					},
				],
				columns2: [{
						title: '动物品种、品系',
						dataIndex: 'aniType',
						scopedSlots: {
							customRender: 'aniType'
						},
						width: 150
					},
					// {
					// 	title: '性别',
					// 	dataIndex: 'level',
					// 	scopedSlots: {
					// 		customRender: 'level'
					// 	},
					// 	width:150
					// },
					{
						title: '年龄',
						dataIndex: 'AgeWeight',
						scopedSlots: {
							customRender: 'AgeWeight'
						},
						width: 150
					},
					{
						title: '体重',
						dataIndex: 'AgeWeight2',
						scopedSlots: {
							customRender: 'AgeWeight2'
						},
						width: 150
					},
					{
						title: '性别',
						dataIndex: 'nums_1',
						scopedSlots: {
							customRender: 'nums_1'
						},
						width: 150
					},
					{
						title: '数量',
						dataIndex: 'nums_2',
						scopedSlots: {
							customRender: 'nums_2'
						},
						width: 150
					},
					{
						title: '运输方式',
						dataIndex: 'company',
						scopedSlots: {
							customRender: 'company'
						},
						width: 150
					},
					{
						title: '饲养环境',
						dataIndex: 'license',
						scopedSlots: {
							customRender: 'license'
						},
						width: 150
					},
					// {
					// 	title: '实施地点',
					// 	dataIndex: 'locale',
					// 	scopedSlots: {
					// 		customRender: 'locale'
					// 	},
					// 	width:150
					// },
					{
						title: '是否要求繁殖动物',
						dataIndex: 'ifBreeding',
						scopedSlots: {
							customRender: 'ifBreeding'
						},
						width: 150
					},
					// {
					// 	title: '饲养时间',
					// 	dataIndex: 'breedingTime',
					// 	scopedSlots: {
					// 		customRender: 'breedingTime'
					// 	},
					// 	width:150
					// },
					{
						title: '特殊要求',
						dataIndex: 'spRequest',
						scopedSlots: {
							customRender: 'spRequest'
						},
						width: 150
					},
					{
						title: '是否使用基因修饰动物',
						dataIndex: 'ifGene',
						scopedSlots: {
							customRender: 'ifGene'
						},
						width: 180
					},

					{
						title: '编辑',
						dataIndex: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
						aligh: 'center',
						width: 80,
						fixed: 'right',
					},
				],

				form: {
					newCode: {
						entryName: '',
						text1: '', //解释为什么你的研究中将要使用的动物种类是合理的
						textMsg1: '',
						text2: '', //在本实验中使用活体动物的理由是什么
						textMsg2: '',
						text3: '', //所需动物数量的依据
						textMsg3: '',
						text4: '', //至少列出2种查阅的数据库（如：中国知网、PubMed等）
						text5: '', //检索日期
						text6: '', //检索涵盖的年份
						text7: '', //动物福利相关的关键词（如：动物模型，非动物模型，在体外、替代、组织等）
						text8: '', //项目相关的关键词
						text9: '', //请描述有无活体动物的替代方法
						text10: '', //请描述有无活体动物的替代方法
						text11: '', //繁殖方式
						text12: '', //乳鼠鉴定时间
						text13: '', //离乳时间
						text14: '', //阴性鼠处理方式
						text15: '', //实验分组（描述实验组、对照组、动物数）
						text16: '', //频率（于实验第几天？）
						text17: '', //采血部位 
						text18: '', //每次每只动物的最大采血
						text19: '', //预期实验会对动物造成的伤害
						textMsg19: '', //其它异常临床症状需要说明的情况
						text20: '', //主要实验流程（造模或手术过程）
						text21: '', //是否使用有毒化学品或药品来源
						text22: '', //是否使用重组DNA或病原微生物来源
						text23: '', //对直接接触人员可能的进入途径
						text23Msg: '', //对直接接触人员可能的进入途径（具体说明）
						text24: '', //对人员健康的潜在危害性
						text25: '', //防护性措施
						text26: '', //1类：仅引起短暂性的疼痛，无需麻醉；或无痛、无应激
						text27: '', //2类：可用适当方法减轻疼痛和/或应激
						textMsg28: '', //3类：不能使用适当方法以减轻疼痛或持续性不适说明（麻醉药品及麻醉方式）


					},
					newPage: {
						boss: {
							name: '',
							phone: '',
							email: ''
						},
						people: {
							name: '',
							phone: '',
							email: ''
						}
					},
					item1: {
						itemName: "", //项目名称
						itemSource: "", //项目来源
						company: "", //单位名称
						itemType: "",
						itemNum: "", //项目编号
						approvalNo: "", //动物福利伦理审查号


					},
					item2: {
						changeMsg: "", //变更内容
						draftMethod: "", //拟更改实验方法
						orginMethod: "", //原实验方法
						otherMethod: "", //其他实验方法
						reason: '',
						facilitiesNum: '',
						origin: {
							startTime: "",
							endTime: "",
						},
						draw: {
							startTime: "",
							endTime: "",
						},
						peopleMsg: [{
							name: "",
							sex: "",
							department: "",
							certificate: "", //证书编号
							experience: "", //动物实验经验
							ability: "", //培训及能力描述
							key: 0,
						}],
						animalMsg: [{
							key: 0,
							aniType: "", //动物品系
							level: "", //级别
							AgeWeight: "", //年龄体重
							nums_1: "", //公数量
							nums_2: "", //母数量
							company: "", //供应单位
							license: "", //培训及能力描述,
							locale: ""

						}]
					},
					item3: {
						key: "1",
						experProcess: [{
							key: 0,

							exTxt: "",
							exTime: "",

						}],
						pillType: [{
							key: 0,
							drugType: '',
							name: "",
							dose: "",
							position: "",

							time: ""

						}],
						sampleCol: [{
							key: 0,
							name: '',
							position: "",
							times: "",
							way: "",
						}],
						textarea1: "", //说明必须使用动物而不用非动物替代方法及选择实验动物种类和数量的原因。描述针对3R原则中动物替代和减少动物用量所采用的主要措施。
						textarea2: "", //现有动物实验设施条件是否与拟开展动物实验的规范性要求相匹配的描述。
						textarea3: "", //动物实验项目的目的、必要性、意义和如何设计以达成研究目标的？
					},
					item4: {
						isGeneti: '',
						isSample: "",
						isDna: '',
						isPill: "",
						isBlood: '',
						death: "", //处死动物的方法
						isToxicPill: '',
						isPain: '',
						isToxic: "", //.是否使用有毒（害）物质（感染、放射、化学毒、其他）
						nonkilled: "", //非处死动物的处置方法
						nonkilled2: '',
						textarea1: "", //实验方案：应包括动物分组及数量,实验操作(如保定、注射、灌胃、采血和非存活手术或存活手术等)。
						textarea2: "", //详细列出对动物可能造成的所有可预期的伤害，包括动物运输，动物饲养方式（如单笼饲养）、实验操作步骤中等可能产生伤害或不适的细节以及拟采取的防控优化措施(包括麻醉、止痛和镇静，保温，环境丰容等)。涉及给药，应列出药物名称、剂量、给药途径及时间。
						textarea3: "", //仁慈终点或实验终结的指标(既终止实验的时机)。
						textarea4: "", //动物处死方法
						textarea5: "", //非处死动物的处置方法
						textarea6: "", //是否使用有毒（害）物质（感染、放射、化学毒、其他）？
						textarea7: "", //相关的补充说明或辅助证明文件
						textarea8: "", //信息公开和保密要求：说明哪些信息需要保密，哪些信息可以公开？
						textarea9: "", //对伦理委员有无回避要求？

					}
				},
				rules: {
					item1: {
						itemName: [{
							required: true,
							message: '项目名称不能为空，请填写',
							trigger: 'blur'
						}],
						itemType: [{
							required: true,
							message: '项目类型不能为空，请勾选',
							trigger: 'change'
						}, ],
						itemNum: [{
							required: true,
							message: '项目编号不能为空，请填写',
							trigger: 'blur'
						}],
						itemSource: [{
							required: true,
							message: '项目来源不能为空，请填写',
							trigger: 'blur'
						}],

						approvalNo: [{
							required: true,
							message: '动物福利伦理审查号不能为空，请填写',
							trigger: 'blur'
						}],



					},
					item2: {
						draftMethod: [{
							required: true,
							message: '拟更改实验方法不能为空，请填写',
							trigger: 'blur'
						}],
						originMethod: [{
							required: true,
							message: '原实验方法不能为空，请填写',
							trigger: 'blur'
						}],
						otherMethod: [{
							required: true,
							message: '其他实验方法不能为空，请填写',
							trigger: 'blur'
						}],
					},
					item3: {
						textarea1: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea2: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea3: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],

					},
					item4: {
						textarea1: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea2: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea3: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea4: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea5: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea6: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea7: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea8: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						textarea9: [{
							required: true,
							message: '该信息不能为空，请填写',
							trigger: 'blur'
						}],
						death: [{
							type: 'array',
							required: true,
							message: '请至少勾选一项',
							trigger: 'change',
						}, ],
						nonkilled: [{
							type: 'array',
							required: true,
							message: '请至少勾选一项',
							trigger: 'change',
						}, ],
						isToxic: [{
							required: true,
							message: '请至少勾选一项',
							trigger: 'change'
						}, ],
					},
					name: [{
							required: true,
							message: 'Please input Activity name',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 5,
							message: 'Length should be 3 to 5',
							trigger: 'blur'
						},
					],
					region: [{
						required: true,
						message: 'Please select Activity zone',
						trigger: 'change'
					}],
					date1: [{
						required: true,
						message: 'Please pick a date',
						trigger: 'change'
					}],
					type: [{
						type: 'array',
						required: true,
						message: 'Please select at least one activity type',
						trigger: 'change',
					}, ],
					resource: [{
						required: true,
						message: 'Please select activity resource',
						trigger: 'change'
					}, ],
					desc: [{
						required: true,
						message: 'Please input activity form',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			changeTimes(date) {
				this.form.item2.draw.endTime = moment(this.form.item2.draw.startTime).add('30', 'days')
			},
			async EthicalChangePiReview(state){
				
				const res = await axios.post('/Flat/EthicalChangePiReview', Qs.stringify({id:Number(this.$route.query.id),State:state}))
				if(res.data.state){
					this.$message.success(res.data.info)
					this.$router.push({path:'/core/reviewChange'})
				}
				else{
					this.$message.error(res.data.info)
				}
				
			},
			onlyValues(state) {
				if (state == 1) {
					this.form.item4.isPain = ''
					this.form.newCode.text27 = ''
				}
				if (state == 2) {

					this.form.item4.isPain = ''
					this.form.newCode.text26 = ''
				}
				if (state == 3) {

					this.form.newCode.text27 = ''
					this.form.newCode.text26 = ''
				}
			},
			async SelUserList(data) {
				const res = await SelUserList()
				res.data.data.map((n) => {
					if (n.userId == data.data[0].tutorId) {
						this.form.newPage.boss.name = n.realName
						this.form.newPage.boss.email = n.email
						this.form.newPage.boss.phone = n.tol

					}

				})
				res.data.data.map((n) => {
					if (n.userId == data.data[0].applicantId) {

						this.form.newPage.people.name = n.realName
						this.form.newPage.people.email = n.email
						this.form.newPage.people.phone = n.tol
					}

				})

			},
			disabledDate(current) {
				// return moment(new Date())
				return current && current < moment().add('15', 'days')
			},
			disabledDate2(current) {
				// return moment(new Date())
				return current && current < moment(this.form.item2.draw.startTime).add('30', 'days')
				// console.log(current)
				// console.log(this.form.item2.startTime)
				// debugger
			},
			onSubmit() {
				console.log(this.form.item2.draw.endTime)
				// console.log(JSON.stringify(this.form.item2.changeMsg))
				// console.log(this.form.item2.changeMsg)
				this.$refs.ruleForm.validate(valid => {

					console.log("测试")
					if (valid) {
						let FORMS = {
							Animal: JSON.stringify(this.form.item2.animalMsg),
							ChangeReason: this.form.item2.reason,
							CloseDate: this.form.item2.draw.endTime ? this.form.item2.draw.endTime._d : '',
							OpenDate: this.form.item2.draw.startTime ? this.form.item2.draw.startTime._d : '',
							EthicalReviewForTeachId: this.ethicsChangeData.ethicalReviewForTeachId,
							Iacuc: this.form.item1.approvalNo,
							Participants: JSON.stringify(this.form.item2.peopleMsg),
							Type: JSON.stringify(this.form.item2.changeMsg),

							Explain1: this.form.item3.textarea1,
							Explain2: this.form.item3.textarea2,
							Explain3: this.form.item3.textarea3,
							Explain4: this.form.item4.textarea1,
							Explain5: this.form.item4.textarea2,
							Explain6: this.form.item4.textarea3,
							Explain7: this.form.item4.death != '' ? JSON.stringify(this.form.item4.death) :
								this.form.item4.death,
							ExplainF8: this.form.item4.nonkilled2,
							Explain8: this.form.item4.nonkilled != '' ? JSON.stringify(this.form.item4
								.nonkilled) : this.form.item4.nonkilled,
							Explain9: this.form.item4.textarea4,
							Explain10: this.form.item4.textarea5,
							Explain11: this.form.item4.isToxic,
							Explainf12: this.fileList && this.fileList.length > 0 ? this.fileList[0].response
								.data.data[0].path : '',
							Explain12: this.form.item4.textarea7,
							Explain13: this.form.item4.textarea6,
							Explain14: this.form.item4.textarea8,
							Explain15: this.form.item4.textarea9,
							FilePathList: this.fileList && this.fileList.length > 0 ? JSON.stringify(this
								.fileList) : [],
							iacuc1: this.form.newCode.entryName,
							iacuc2: this.form.newCode.text1 != '' ? JSON.stringify(this.form.newCode.text1) :
								this.form.newCode.text1,
							iacuc3: this.form.newCode.textMsg1,
							iacuc4: this.form.newCode.text2 != '' ? JSON.stringify(this.form.newCode.text2) :
								this.form.newCode.text2,
							iacuc5: this.form.newCode.textMsg2,
							iacuc6: this.form.newCode.text3 != '' ? JSON.stringify(this.form.newCode.text3) :
								this.form.newCode.text3,
							iacuc7: this.form.newCode.textMsg3,
							iacuc8: this.form.newCode.text4,
							iacuc9: this.form.newCode.text5 ? moment(this.form.newCode.text5).format(
								'YYYY-MM-DD HH:mm:ss') : this.form.newCode.text5,
							iacuc10: this.form.newCode.text6,
							iacuc11: this.form.newCode.text7,
							iacuc12: this.form.newCode.text8,
							iacuc13: this.form.newCode.text9,
							iacuc15: this.form.item4.isGeneti,
							iacuc16: this.form.newCode.text11,
							iacuc17: this.form.newCode.text12,
							iacuc18: this.form.newCode.text13,
							iacuc19: this.form.newCode.text14,
							iacuc20: this.form.newCode.text15,
							iacuc21: JSON.stringify(this.form.item3.experProcess),
							iacuc22: this.form.item4.isPill,
							iacuc23: JSON.stringify(this.form.item3.pillType),
							iacuc24: this.form.item4.isBlood,
							iacuc25: this.form.newCode.text16,
							iacuc26: this.form.newCode.text17,
							iacuc27: this.form.newCode.text18,
							iacuc28: this.form.newCode.text19 != '' ? JSON.stringify(this.form.newCode
								.text19) : this.form.newCode.text19,
							iacuc29: this.form.newCode.textMsg19,
							iacuc30: this.form.newCode.text20,
							iacuc31: this.form.item4.isSample,
							iacuc32: JSON.stringify(this.form.item3.sampleCol),
							iacuc33: this.form.item4.isDna,
							iacuc14: this.form.newCode.text22,
							iacuc34: this.form.newCode.text23 != '' ? JSON.stringify(this.form.newCode
								.text23) : this.form.newCode.text23,
							iacuc35: this.form.newCode.text23Msg,
							iacuc36: this.form.newCode.text24,
							iacuc37: this.form.newCode.text25 != '' ? JSON.stringify(this.form.newCode
								.text25) : this.form.newCode.text25,
							iacuc38: this.form.newCode.text26,
							iacuc39: this.form.newCode.text27,
							iacuc40: this.form.item4.isPain,
							iacuc41: this.form.newCode.textMsg28,



						}
						console.log("测试")
						console.log(FORMS)
						if (this.$route.query.id&&this.$route.query.states!='申请新增') {
							FORMS.EthicalChangeId = this.ethicsChangeData.ethicalChangeId
							FORMS.EthicalReviewForTeachId = undefined
							const res = UpdateEthicalChange(FORMS).then((res) => {
								console.log(res)
								if (res.data.state == true) {
									this.$message.success("修改申请成功")
									this.$router.push({
										path: '/core/reviewChange'
									})
								} else {
									this.$message.error(res.data.info)
								}
							})
						} else {
							const res = AppEthicalChange(FORMS).then((res) => {
								console.log(res)
								if (res.data.state == true) {
									this.$message.success("申请新增成功")
									this.$router.push({
										path: '/core/reviewChange'
									})
								} else {
									this.$message.error(res.data.info)
								}
							})
						}

					} else {
						this.$message.error("请填写必填信息")
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleAdd() {
				let {
					count,
					form
				} = this;
				count += 1
				const newData = {
					key: count,
					name: "",
					sex: "",
					department: "",
					certificate: "", //证书编号
					experience: "", //动物实验经验
					ability: "", //培训及能力描述	
				};
				this.form.item2.peopleMsg = [...form.item2.peopleMsg, newData];
				this.count = count + 1;
			},
			handleAdd2() {
				let {
					count,
					form
				} = this;
				count += 1
				const newData = {
					key: count,
					name: "",
					sex: "",
					department: "",
					certificate: "", //证书编号
					experience: "", //动物实验经验
					ability: "", //培训及能力描述
					locale: ""
				};
				this.form.item2.animalMsg = [...form.item2.animalMsg, newData];
				this.count = count + 1;
			},
			changeItemType(e) {

				if (e.target.value == '其他') {
					this.ItemTypeHide = true
				} else {
					this.ItemTypeHide = false
				}
			},
			selectedTypes(val) {},
			onDelete(key) {
				const dataSource = [...this.form.item2.peopleMsg];
				if (this.form.item2.peopleMsg.length == 1) {
					this.$message.error("删除失败，至少填写一行数据")
					return
				}
				this.form.item2.peopleMsg = dataSource.filter(item => item.key !== key);
			},
			onDelete2(key) {
				const dataSource = [...this.form.item2.animalMsg];
				if (this.form.item2.animalMsg.length == 1) {
					this.$message.error("删除失败，至少填写一行数据")
					return
				}
				this.form.item2.animalMsg = dataSource.filter(item => item.key !== key);
			},
			onCellChange(key, dataIndex, value) {
				const dataSource = [...this.form.item2.animalMsg];
				const target = dataSource.find(item => item.key === key);

				if (target) {
					target[dataIndex] = value.target ? value.target.value : value;
					this.form.item2.animalMsg = dataSource;
				}
			},
			onCellChange2(key, dataIndex, value) {
				const dataSource = [...this.form.item2.peopleMsg];
				const target = dataSource.find(item => item.key === key);

				if (target) {
					target[dataIndex] = value.target ? value.target.value : value;
					this.form.item2.peopleMsg = dataSource;
				}
				console.log(this.form.item2.peopleMsg)
			},
			onCellChange3(key, dataIndex, value) {
				const dataSource = [...this.form.item3.experProcess];
				const target = dataSource.find(item => item.key === key);
				if (target) {
					target[dataIndex] = value.target ? value.target.value : value;
					this.form.item3.experProcess = dataSource;
				}

			},
			onCellChange4(key, dataIndex, value) {
				const dataSource = [...this.form.item3.pillType];
				const target = dataSource.find(item => item.key === key);
				if (target) {
					target[dataIndex] = value.target ? value.target.value : value;
					this.form.item3.pillType = dataSource;
				}

			},
			onCellChange5(key, dataIndex, value) {
				const dataSource = [...this.form.item3.sampleCol];
				const target = dataSource.find(item => item.key === key);
				if (target) {
					target[dataIndex] = value.target ? value.target.value : value;
					this.form.item3.sampleCol = dataSource;
				}

			},
			handleAdd3() {
				console.log(this.count)
				let {
					count,
					form
				} = this;
				count += 1
				const newData = {
					key: count,
					exTime: "",
					exTxt: "",
				};
				this.form.item3.experProcess = [...form.item3.experProcess, newData];
				this.count = count + 1;
			},
			handleAdd4() {
				console.log(this.count)
				let {
					count,
					form
				} = this;
				count += 1
				const newData = {
					key: count,
					drugType: '',
					name: "",
					dose: "",
					position: "",
					time: ""
				};
				this.form.item3.pillType = [...form.item3.pillType, newData];
				this.count = count + 1;
			},
			handleAdd5() {
				console.log(this.count)
				let {
					count,
					form
				} = this;
				count += 1
				const newData = {
					key: count,
					name: '',
					position: "",
					times: "",
					way: "",
				};
				this.form.item3.sampleCol = [...form.item3.sampleCol, newData];
				this.count = count + 1;
			},
			onDelete3(key) {
				const dataSource = [...this.form.item3.experProcess];
				if (this.form.item3.experProcess.length == 1) {
					this.$message.error("删除失败，至少填写一行数据")
					return
				}
				this.form.item3.experProcess = dataSource.filter(item => item.key !== key);
			},
			onDelete4(key) {
				const dataSource = [...this.form.item3.pillType];
				if (this.form.item3.pillType.length == 1) {
					this.$message.error("删除失败，至少填写一行数据")
					return
				}
				this.form.item3.pillType = dataSource.filter(item => item.key !== key);
			},
			onDelete5(key) {
				const dataSource = [...this.form.item3.sampleCol];
				if (this.form.item3.sampleCol.length == 1) {
					this.$message.error("删除失败，至少填写一行数据")
					return
				}
				this.form.item3.sampleCol = dataSource.filter(item => item.key !== key);
			},
		},
		inject: ['reload'],
		watch: {
			$route() {
				this.reload()
			}
		},
		created() {
			if (this.$route.query.states == '申请新增') {
				this.form.item2.peopleMsg = []
				this.form.item2.animalMsg = []
				this.form.item3.experProcess = []
				SelIacuc({
					EthicalReviewForTeachId: this.$route.query.id,
					page: 1,
					limit: 1
				}).then((res) => {
					this.SelUserList(res.data)
					let data = {}
					data = res.data.data[0]
					this.ethicsChangeData = data

					// this.form.
					this.form.item1.itemName =  this.ethicsChangeData.room
					this.form.item1.itemType = this.ethicsChangeData.courseName
					this.ItemTypeHide = true
					// this.form.item1.itemSource = this.ethicsChangeData.teacher 
					this.form.item1.itemNum = this.ethicsChangeData.email
					console.log(JSON.parse(this.ethicsChangeData.animal))
					this.form.item2.animalMsg = JSON.parse(this.ethicsChangeData.animal)
					this.form.item2.peopleMsg = JSON.parse(this.ethicsChangeData.participants)
					this.form.item1.itemSource = this.ethicsChangeData.teacher
					this.form.item2.origin.startTime = this.ethicsChangeData.openDate
					this.form.item2.origin.endTime = this.ethicsChangeData.closeDate
					this.form.item2.orginMethod = this.ethicsChangeData.explain4

					this.form.newCode.entryName = data.iacuc1
					this.form.newCode.text1 = JSON.parse(data.iacuc2)
					this.form.newCode.textMsg1 = data.iacuc3
					this.form.newCode.text2 = JSON.parse(data.iacuc4)
					this.form.newCode.textMsg2 = data.iacuc5
					this.form.newCode.text3 = JSON.parse(data.iacuc6)
					this.form.newCode.textMsg3 = data.iacuc7
					this.form.newCode.text4 = data.iacuc8
					this.form.newCode.text5 = data.iacuc9
					this.form.newCode.text6 = data.iacuc10
					this.form.newCode.text7 = data.iacuc11
					this.form.newCode.text8 = data.iacuc12
					this.form.newCode.text9 = data.iacuc13
					this.form.item4.isGeneti = data.iacuc15
					this.form.newCode.text11 = data.iacuc16
					this.form.newCode.text12 = data.iacuc17
					this.form.newCode.text13 = data.iacuc18
					this.form.newCode.text14 = data.iacuc19
					this.form.newCode.text15 = data.iacuc20
					this.form.item3.experProcess = JSON.parse(data.iacuc21)
					this.form.item4.isPill = data.iacuc22
					this.form.item3.pillType = JSON.parse(data.iacuc23)
					this.form.item4.isBlood = data.iacuc24
					this.form.newCode.text16 = data.iacuc25
					this.form.newCode.text17 = data.iacuc26
					this.form.newCode.text18 = data.iacuc27
					this.form.newCode.text19 = JSON.parse(data.iacuc28)
					this.form.newCode.textMsg19 = data.iacuc29
					this.form.newCode.text20 = data.iacuc30
					this.form.item4.isSample = data.iacuc31
					this.form.item3.sampleCol = JSON.parse(data.iacuc32)
					this.form.item4.isDna = data.iacuc33
					this.form.newCode.text22 = data.iacuc14
					this.form.newCode.text23 = JSON.parse(data.iacuc34)
					this.form.newCode.text23Msg = data.iacuc35
					this.form.newCode.text24 = data.iacuc36
					this.form.newCode.text25 = JSON.parse(data.iacuc37)
					this.form.newCode.text26 = data.iacuc38
					this.form.newCode.text27 = data.iacuc39
					this.form.item4.isPain = data.iacuc40
					this.form.newCode.textMsg28 = data.iacuc41
					this.form.item2.facilities = data.iacuc42
					this.form.item2.facilitiesNum = data.iacuc43
					this.form.item3.textarea1 = data.explain1
					this.form.item3.textarea3 = data.explain3
					this.form.item4.isToxic = data.explain11
					this.form.item4.textarea6 = data.explain13
					this.form.item4.textarea2 = data.explain5


					this.form.item4.death = JSON.parse(data.explain7)
					this.form.item4.nonkilled = JSON.parse(data.explain8)
					this.form.item4.nonkilled2 = data.explainF8
					// this.fileList = JSON.parse(data.filePathList) 
					this.form.item4.textarea4 = data.explain9
					this.form.item4.textarea5 = data.explain10
					this.form.item4.isToxic = data.explain11
					// Explainf12:'/file/',
					this.form.item4.textarea7 = data.explain12
					this.form.item4.textarea6 = data.explain13
					this.form.item4.textarea8 = data.explain14
					this.form.item4.textarea9 = data.explain15
					this.form.item4.textarea3 = data.explain6
					// if(this.$route.query.id){
					// 	this.form.item1.approvalNo = data.iacuc
					// 	this.form.item2.changeMsg = JSON.parse(data.type)
					// 	this.form.item2.reason = data.changeReason
					// 	this.form.item1.itemName=data.lroom
					// 	this.form.item1.itemType = data.ltype 
					// 	this.form.item2.origin.startTime = data.lopenDate
					// 	this.form.item2.origin.endTime = data.lcloseDate
					// 	this.form.item2.draw.startTime = this.ethicsChangeData.openDate
					// 	this.form.item2.draw.endTime = this.ethicsChangeData.closeDate
					// 	this.form.item2.draftMethod = data.explain4
					// 	this.form.item2.orginMethod = data.explainf4
					// 	this.form.item2.otherMethod = data.other
					// 	let Count1 = this.form.item2.animalMsg.map((n)=>{
					// 		return n.key
					// 	})
					// 	let Count2 = this.form.item2.peopleMsg.map((n)=>{
					// 		return n.key
					// 	})
					// 	let maxCount1 = Math.max(...Count1)
					// 	let maxCount2 = Math.max(...Count2)
					// 	this.count = maxCount1>maxCount2?maxCount1:maxCount2
					// }
				})
			}
			if (this.$route.query.states == '编辑' || this.$route.query.states == 'PI审核') {
				this.form.item2.peopleMsg = []
				this.form.item2.animalMsg = []
				this.form.item3.experProcess = []
				SelEthicalChange({
					EthicalChangeId: this.$route.query.id,
					page: 1,
					limit: 1
				}).then((res) => {
					this.SelUserList(res.data)
					let data = {}
					data = res.data.data[0]
					this.ethicsChangeData = data
					// this.form.
					this.form.item1.itemName = this.$route.query.id && this.$route.params.data ? this
						.ethicsChangeData.ltype : this.ethicsChangeData.room
					this.form.item1.itemType = this.ethicsChangeData.courseName
					this.ItemTypeHide = true
					// this.form.item1.itemSource = this.ethicsChangeData.teacher 
					this.form.item1.itemNum = this.ethicsChangeData.email
					console.log(JSON.parse(this.ethicsChangeData.animal))
					this.form.item2.animalMsg = JSON.parse(this.ethicsChangeData.animal)
					this.form.item2.peopleMsg = JSON.parse(this.ethicsChangeData.participants)
					this.form.item1.itemSource = this.ethicsChangeData.teacher
					this.form.item2.origin.startTime = this.ethicsChangeData.openDate
					this.form.item2.origin.endTime = this.ethicsChangeData.closeDate
					this.form.item2.orginMethod = this.ethicsChangeData.explain4


					if (this.$route.query.id) {
						this.form.item1.approvalNo = data.iacuc
						this.form.item2.changeMsg = JSON.parse(data.type)
						this.form.item2.reason = data.changeReason
						this.form.item1.itemName = data.lroom
						this.form.item1.itemType = data.ltype
						this.form.item2.origin.startTime = data.lopenDate
						this.form.item2.origin.endTime = data.lcloseDate
						this.form.item2.draw.startTime = this.ethicsChangeData.openDate
						this.form.item2.draw.endTime = this.ethicsChangeData.closeDate
						this.form.item2.draftMethod = data.explain4
						this.form.item2.orginMethod = data.explainf4
						this.form.item2.otherMethod = data.other


						this.form.newCode.entryName = data.iacuc1
						this.form.newCode.text1 = JSON.parse(data.iacuc2)
						this.form.newCode.textMsg1 = data.iacuc3
						this.form.newCode.text2 = JSON.parse(data.iacuc4)
						this.form.newCode.textMsg2 = data.iacuc5
						this.form.newCode.text3 = JSON.parse(data.iacuc6)
						this.form.newCode.textMsg3 = data.iacuc7
						this.form.newCode.text4 = data.iacuc8
						this.form.newCode.text5 = data.iacuc9
						this.form.newCode.text6 = data.iacuc10
						this.form.newCode.text7 = data.iacuc11
						this.form.newCode.text8 = data.iacuc12
						this.form.newCode.text9 = data.iacuc13
						this.form.item4.isGeneti = data.iacuc15
						this.form.newCode.text11 = data.iacuc16
						this.form.newCode.text12 = data.iacuc17
						this.form.newCode.text13 = data.iacuc18
						this.form.newCode.text14 = data.iacuc19
						this.form.newCode.text15 = data.iacuc20
						this.form.item3.experProcess = JSON.parse(data.iacuc21)
						this.form.item4.isPill = data.iacuc22
						this.form.item3.pillType = JSON.parse(data.iacuc23)
						this.form.item4.isBlood = data.iacuc24
						this.form.newCode.text16 = data.iacuc25
						this.form.newCode.text17 = data.iacuc26
						this.form.newCode.text18 = data.iacuc27
						this.form.newCode.text19 = JSON.parse(data.iacuc28)
						this.form.newCode.textMsg19 = data.iacuc29
						this.form.newCode.text20 = data.iacuc30
						this.form.item4.isSample = data.iacuc31
						this.form.item3.sampleCol = JSON.parse(data.iacuc32)
						this.form.item4.isDna = data.iacuc33
						this.form.newCode.text22 = data.iacuc14
						this.form.newCode.text23 = JSON.parse(data.iacuc34)
						this.form.newCode.text23Msg = data.iacuc35
						this.form.newCode.text24 = data.iacuc36
						this.form.newCode.text25 = JSON.parse(data.iacuc37)
						this.form.newCode.text26 = data.iacuc38
						this.form.newCode.text27 = data.iacuc39
						this.form.item4.isPain = data.iacuc40
						this.form.newCode.textMsg28 = data.iacuc41
						this.form.item2.facilities = data.iacuc42
						this.form.item2.facilitiesNum = data.iacuc43
						this.form.item3.textarea1 = data.explain1
						this.form.item3.textarea3 = data.explain3
						this.form.item4.isToxic = data.explain11
						this.form.item4.textarea6 = data.explain13
						this.form.item4.textarea2 = data.explain5


						this.form.item4.death = JSON.parse(data.explain7)
						this.form.item4.nonkilled = JSON.parse(data.explain8)

						this.form.item4.nonkilled2 = data.explainF8

						this.form.item4.textarea4 = data.explain9

						this.form.item4.textarea5 = data.explain10
						this.form.item4.isToxic = data.explain11
						// Explainf12:'/file/',
						this.form.item4.textarea7 = data.explain12
						this.form.item4.textarea6 = data.explain13
						this.form.item4.textarea8 = data.explain14
						this.form.item4.textarea9 = data.explain15
						this.form.item4.textarea3 = data.explain6
						let Count1 = this.form.item2.animalMsg.map((n) => {
							return n.key
						})
						let Count2 = this.form.item2.peopleMsg.map((n) => {
							return n.key
						})
						let Count3 = this.form.item3.experProcess.map((n) => {
							return n.key
						})
						let Count4 = this.form.item3.pillType.map((n) => {
							return n.key
						})
						let Count5 = this.form.item3.sampleCol.map((n) => {
							return n.key
						})

						let maxCount1 = Math.max(...Count1)
						let maxCount2 = Math.max(...Count2)

						let maxCount3 = Math.max(...Count3)
						let maxCount4 = Math.max(...Count4)
						let maxCount5 = Math.max(...Count5)
						this.count = Math.max.apply(null, [maxCount1, maxCount2, maxCount3, maxCount4, maxCount5])
					}
				})
			}





		}
	}
</script>

<style scoped>
	.desTitle {
		font-size: 0.875rem;
		color: rgba(0, 0, 0, 0.65);
	}
</style>
<style>
	.ant-pagination {
		display: none;
	}

	.IACUC .ant-input {
		border-color: transparent !important;
		/* cursor: pointer; */
	}
</style>
